<div class="config-container">
    <!-- Sub-tab navigation -->
    <div class="sub-tabs">
        <div *ngFor="let tab of subTabs"
             class="sub-tab"
             [class.active]="selectedTab === tab.id"
             (click)="onSubTabChange(tab.id)">
            {{ tab.translationKey | translate }}
        </div>
    </div>

    <!-- Content area -->
    <div class="config-content" [style.paddingBottom]="displayFooter ? '80px' : '0'">
        <!-- Header with back/create buttons -->
        <app-settings-header
            [title]="headerTitle"
            [showBackButton]="showBackButton"
            [showCreateButton]="showCreateButton"
            [createButtonTranslationKey]="getCreateButtonTranslationKey()"
            (back)="onHeaderBack()"
            (create)="onHeaderCreate()">
        </app-settings-header>

        <!-- List views (when not creating/editing) -->
        <ng-container *ngIf="!isCreatingCategory && !isCreatingDepartment && !isCreatingStatus; else formContent">
            <div class="tab-content" [ngSwitch]="selectedTab">
                <app-category-list *ngSwitchCase="'categories'" (edit)="onEditCategory($event)"></app-category-list>
                <app-department-list *ngSwitchCase="'departments'" (edit)="onEditDepartment($event)"></app-department-list>
                <app-status-list *ngSwitchCase="'statuses'" (edit)="onEditStatus($event)"></app-status-list>
                <app-other-settings *ngSwitchCase="'other'"></app-other-settings>
                <div *ngSwitchDefault>{{ 'request_v2.settings_dialog.coming_soon' | translate }}</div>
            </div>
        </ng-container>

        <!-- Form views (when creating/editing) -->
        <ng-template #formContent>
            <ng-container *ngIf="isCreatingCategory">
                <app-category-form
                    [categoryToEdit]="selectedCategory"
                    (cancel)="onCancelCategoryCreation()"
                    (saved)="onCategorySaved($event)">
                </app-category-form>
            </ng-container>

            <ng-container *ngIf="isCreatingDepartment">
                <app-department-form
                    [departmentToEditId]="selectedDepartment?._id"
                    (cancel)="onCancelDepartmentCreation()"
                    (saved)="onDepartmentSaved($event)">
                </app-department-form>
            </ng-container>

            <ng-container *ngIf="isCreatingStatus">
                <app-status-form
                    [statusIdToEdit]="selectedStatusId"
                    (cancel)="onStatusBack()"
                    (saved)="onStatusSaved($event)">
                </app-status-form>
            </ng-container>
        </ng-template>

        <!-- Footer (when creating/editing) -->
        <app-settings-footer
            *ngIf="displayFooter"
            [buttonText]="footerButtonText"
            (next)="onNextStep()">
        </app-settings-footer>
    </div>
</div>
